const needBankTypes = [12, 13, 14]
export const isNeedBank = typeId => needBankTypes.includes(typeId)
export const numberWithCommas = x => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')



// WEBPACK FOOTER //
// ./src/utils/helpers.js